import Loadable from 'react-loadable';

const LoadableIncodeProvider = Loadable({
  loader: () => import('./IncodeProvider'),
  modules: ['./IncodeProvider'],
  loading: () => null
});

export default LoadableIncodeProvider;
